import React from 'react';
import { Link } from 'react-router-dom';
import '../../App.scss';
import 'antd/dist/antd.css';
import {
  Alert, Spin, Table, Tag, Typography,
} from 'antd';
import moment from 'moment';

import { usePayTipRequests } from '../../models/usePayTipRequests';
import ClientPreview from '../client/ClientPreview';

const { Text } = Typography;

const fmt = (ts) => (ts && typeof ts.toDate === 'function' ? moment(ts.toDate()).format('YYYY-MM-DD HH:mm') : '—');

/** Granted wins over requested; the grandfather flag counts as granted. */
const statusTag = (team) => {
  if (team.payTipAccessGrantedAt || team.isChargeTotalAmount) {
    return <Tag color="green">Granted</Tag>;
  }
  return <Tag color="orange">Requested</Tag>;
};

/**
 * Admin → Clients → Pay+Tip Requests: the grant queue. Every team that
 * pressed Request Access, who asked (ClientPreview — the requester's own
 * avatar/name/profile), when, and whether it has since been granted. The
 * team name links to the ADMIN team page, which nests under the OWNER's
 * client (house route: /admin/clients/{ownerClientId}/teams/{teamId}).
 */
const AdminPayTipRequestsBody = () => {
  const [loading, teams, error] = usePayTipRequests();

  if (loading) return <Spin style={{ marginTop: '40px' }} />;
  if (error) return <Alert type="error" message={error} style={{ margin: '20px' }} />;

  const columns = [
    {
      title: 'Team',
      dataIndex: 'teamName',
      key: 'team',
      render: (teamName, team) => (team.teamOwnerClientId ? (
        <Link to={`/admin/clients/${team.teamOwnerClientId}/teams/${team.teamId}`}>
          {teamName || team.displayName || team.teamId}
        </Link>
      ) : (
        <Text>{teamName || team.displayName || team.teamId}</Text>
      )),
    },
    {
      title: 'Requested by',
      dataIndex: 'payTipRequestedByClientId',
      key: 'requestedBy',
      render: (clientId) => (clientId ? <ClientPreview clientId={clientId} /> : <Text type="secondary">—</Text>),
    },
    {
      title: 'Requested',
      dataIndex: 'payTipRequestedAt',
      key: 'requestedAt',
      render: (ts) => fmt(ts),
    },
    {
      title: 'Currency',
      dataIndex: 'defaultCurrency',
      key: 'currency',
      render: (currency) => currency || '—',
    },
    {
      title: 'Status',
      key: 'status',
      render: (_, team) => statusTag(team),
    },
  ];

  return (
    <Table
      dataSource={teams}
      columns={columns}
      rowKey="teamId"
      pagination={{ pageSize: 25 }}
      style={{ maxWidth: '1000px', margin: '0 auto' }}
    />
  );
};

export default AdminPayTipRequestsBody;
